module.exports = __webpack_public_path__ + "static/media/linkedinDinamic.d8d37ace.gif";